// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"36f173d22d5118e22250","418":"9095decb3b5ebf760fb4","661":"6014c88e7df6b6f53d31"}[chunkId] + ".bundle.js";
};